import $ from 'jquery';
import React, {
    Fragment, useContext, useEffect, useState,
} from 'react';
import { PageStateContext } from '../../context/PageStateContext';

import { getDraftUrl } from '../../utilities/urlHelper';
import { EVENTS, ERROR } from '../../utilities/CONSTANTS';
import editorStateToRawContent from '../../tettra-editor/utilities/editorStateToRawContent';
import editorStateToHTML from '../../tettra-editor/utilities/editorStateToHTML';

const getRawContentState = () => {
    if (window._tettraDraft && window._tettraDraft.editorState && Object.keys(window._tettraDraft.editorState).length) {
        return editorStateToRawContent(window._tettraDraft.editorState);
    }
    return null;
};

const getHTML = () => {
    if (window._tettraDraft && window._tettraDraft.editorState && Object.keys(window._tettraDraft.editorState).length) {
        return editorStateToHTML(window._tettraDraft.editorState);
    }
    return null;
};

const DraftPublish = (props) => {
    const { pageState } = useContext(PageStateContext);
    const draftId = pageState && pageState.draft && pageState.draft.id;
    const [isPublishable, setIsPublishable] = useState(false);

    useEffect(() => {
        setIsPublishable(draftId);
    }, [draftId]);

    const publishPage = () => {
        if (!isPublishable) {
            return;
        }

        if (window._tettraDraft.isUploading) {
            alert(ERROR.IS_UPLOADING);
            return;
        }

        window.dispatchEvent(new Event(EVENTS.DISABLE_AUTO_SAVE));

        const rawContentStateStringified = JSON.stringify(getRawContentState());
        const html = getHTML();
        const {
            id,
            title,
            owner_id,
            category_id = '',
            folder_id = '',
            is_locked,
        } = window._tettraDraft;
        const draftUrl = getDraftUrl(id);

        const $publishDraftForm = $(`<form method="POST" action="${draftUrl}"></form>`)
            .append(`<input name="_token" type="hidden" value="${window.csrfToken}" />`)
            .append('<input name="_method" type="hidden" value="PUT" />')
            .append(`<input name="lockPage" value="${is_locked}" />`)
            .append(`<input name="owner" value="${owner_id}" />`)
            .append($('<textarea name="title" />').text(title))
            .append($('<textarea name="body" />').text(html))
            .append($('<textarea name="editor_state" />').text(rawContentStateStringified));

        if (category_id) {
            $publishDraftForm.append(`<input name="category" value="${category_id}" />`);
        }

        if (folder_id) {
            $publishDraftForm.append(`<input name="folder" value="${folder_id}" />`);
        }

        setIsPublishable(false);

        $publishDraftForm
            .hide()
            .appendTo('body')
            .submit();
    };

    const publishButtonText = (window._tettraDraft && window._tettraDraft.is_template) ? 'Publish template' : 'Publish page';
    const extraClass = isPublishable ? '' : 'is-disabled';

    return (
        <span className={`top-nav-btn btn-primary ml1 ${extraClass}`} onClick={publishPage}>{publishButtonText}</span>
    );
};

export default DraftPublish;
